import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  title?: string
  description: string | React.FC
  primaryLabel?: string
  secondaryLabel?: string
  onConfirm?: () => void
  onSecondary?: () => void
}

export const ConfirmModal: BaseModalType<Props> = (props) => {
  const { close, onConfirm, onSecondary } = props
  const { t } = useTranslation()
  const { title } = props
  const { description: Description } = props
  const { primaryLabel = t('Confirm'), secondaryLabel = t('Cancel') } = props

  const text = typeof Description === 'string' ? Description : <Description />

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{text}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary
          onClick={() => {
            onSecondary?.()
            close()
          }}
        >
          {secondaryLabel}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm?.()
            close()
          }}
        >
          {primaryLabel}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
